import { cn } from "@/lib/utils";
import { useEffect, useRef } from "react";

export const TidalCursor = () => {
  const canvasRef = useRef(null);
  const ripples = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const addRipple = (x, y) => {
      ripples.current.push({ x, y, radius: 0, alpha: 0.6 });
    };

    const handleMove = (e) => {
      addRipple(e.clientX, e.clientY);
    };

    window.addEventListener("mousemove", handleMove);

    const animate = () => {
      if (!ctx || !canvas) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ripples.current.forEach((r) => {
        r.radius += 2;
        r.alpha -= 0.012;

        if (r.alpha > 0) {
          ctx.beginPath();
          ctx.arc(r.x, r.y, r.radius, 0, Math.PI * 2);
          // Verde turquesa de FluenceIA: #00E5A3 = rgb(0, 229, 163)
          ctx.strokeStyle = `rgba(0, 229, 163, ${r.alpha})`;
          ctx.lineWidth = 2.5;
          ctx.stroke();
        }
      });

      ripples.current = ripples.current.filter((r) => r.alpha > 0);
      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", handleMove);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full pointer-events-none"
      style={{ opacity: 0.8, zIndex: 15 }}
    />
  );
};

export default TidalCursor;
